import { Node } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import Component from './PrettyAnchor.vue'

export default Node.create({
  name: 'PrettyAnchor',
  group: 'block',
  content: 'block*',

  addAttributes() {
    return {
    class:{
        default:'havet-pretty-anchor'
    },
    href:{
        default:''
    },
    }
  },

  parseHTML() {
    
    return [
      {
        priority: 101,
        tag: 'a',
        getAttrs: (el) => {
            return el.classList.contains('havet-pretty-anchor') && null;
        },
      },
    ]
  },

  renderHTML({HTMLAttributes}) {
    return ['a', HTMLAttributes, 
    ['div', {class:'wrapper'}, ['div', {}, 0],['div', {class:'chevron'},]]
    ]
  },

  addNodeView() {
    return VueNodeViewRenderer(Component)
  },
})